module.exports = __webpack_public_path__ + "static/media/crooked-little-house-cover.16e0ef26.jpg";